import {
  SET_STATISTICS_DATA,
  SET_SELECTED_STATISTICS_MODEL,
  CLEAR_STATISTICS_DATA,
} from "./mutations";

const setStatisticsData = (payload) => ({
  type: SET_STATISTICS_DATA,
  payload,
});

const setSelectedStatisticsModel = (payload) => ({
  type: SET_SELECTED_STATISTICS_MODEL,
  payload,
});

const clearStatisticsData = () => ({
  type: CLEAR_STATISTICS_DATA,
  payload: {},
});

export { setStatisticsData, setSelectedStatisticsModel, clearStatisticsData };
